import { TextPairing } from '@components/TextPairing';
import { Box } from '@components/Box';
import { styled } from '@styledComponents';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import Carousel from 'nuka-carousel';
import { PlaceholderCloudImage } from '@components/CloudImage';
import { Flex } from '@components/Flex';

export const AllTheLittleDetailsSectionContainer = styled(Box)`
  position: relative;
  width: 100%;
  z-index: 0;
`;

// This controls height of CustomizeTheme section. Needs a unit, can't be a Percentage here.
export const ContentWrapper = styled(Box)`
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  max-height: 600vh;
  left: 0;
  width: 100%;
  padding-bottom: 0px;

  ${themeMediaQuery('below_sm')} {
    flex-direction: column;
    height: 100%;
  }

  &.pinned {
    position: fixed;
  }
`;

// new highlights box!
export const HighlightsContainer = styled(Box)`
  position: relative;
  width: 310px;
  margin-left: auto;
  margin-right: 9%;
  height: 100%;
  text-align: left;

  ${themeMediaQuery('below_sm')} {
    width: 100%;
    height: 400px;
    margin: 0px;
    margin-top: ${themeSpace(6)};
    overflow: hidden;
  }
`;

export const CarouselWrapper = styled(Box)<{ activeIndex: number }>`
  ${themeMediaQuery('below_sm')} {
    position: absolute;
    display: flex;
    flex-direction: row;
    left: ${props => -80 * (props.activeIndex || 0) + 10}vw;
    transition: all 0.3s ease;
  }
`;

export const CarouselHorizontalWrapper = styled(Carousel)`
  ${themeMediaQuery('below_sm')} {
    position: absolute;
    display: flex;
    flex-direction: row;
    left: 10vw;
    transition: all 0.3s ease;
  }
`;

export const HighlightsBlock = styled(TextPairing).attrs({ className: 'customize-theme-highlights-block' })`
  position: absolute;
  top: 100%;
  margin-left: ${themeSpace(6)};

  ${themeMediaQuery('sm')} {
    max-width: 310px;
    width: 310px;
    margin-left: 0px;
  }

  ${themeMediaQuery('below_sm')} {
    position: relative;
    top: 0%;
    max-width: 80vw;
    width: 80vw;
    margin: 0px;
    padding-left: ${themeSpace(5)};
    padding-right: ${themeSpace(5)};
  }
`;

export const HandCraftedDesignsBlock = styled(HighlightsBlock)`
  top: 50% !important;

  ${themeMediaQuery('below_sm')} {
    top: 0% !important;
  }
`;

export const StyledDotIndicator = styled.div`
  margin-left: 10vw;
  padding-left: ${themeSpace(5)};
  position: absolute;
  bottom: ${themeSpace(12)};
  display: flex;
  z-index: 1;
  ul {
    display: flex;
    div + div {
      margin-left: 16px;
    }
  }
`;

export const HighlightSectionWrapper = styled(Box)`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const DesignPlaceholderCloudImage = styled(PlaceholderCloudImage)`
  width: 106%;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    margin-left: -20px;
  }
  ${themeMediaQuery('sm')} {
    width: 530px;
    height: 344px;
  }
  ${themeMediaQuery('md')} {
    width: 731px;
    height: 474px;
  }
  @media screen and (min-width: 87.5rem) {
    width: 890px;
    height: 577px;
  }
  ${themeMediaQuery('lg')} {
    width: 916px;
    height: 594px;
  }
  ${themeMediaQuery('xl')} {
    width: 1212px;
    height: 786px;
  }
`;

export const DesignImageBox = styled(Box).attrs({ className: 'customized-theme-image-block' })`
  width: 100%;
  opacity: 0;
  position: absolute;
  transition: opacity 1.5s ease-in-out;
  &.design-image-visible {
    opacity: 1;
`;

export const DesignImageBoxFirstItem = styled(DesignImageBox)`
  opacity: 1;
  position: absolute;
  &.design-image-hide {
    opacity: 0;
  }
`;

export const DesignImagesWrapper = styled(Flex)`
  width: 60%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  position: relative;
  ${themeMediaQuery('below_sm')} {
    width: 95%;
  }
`;
